import type { CurrentUser } from "./adminAuth";
import type { AdminRole } from "./adminApi";

export const hasRole = (me: CurrentUser | undefined, role: AdminRole) =>
  !!me?.roles?.includes(role);

export const isSuperAdmin = (me: CurrentUser | undefined) => hasRole(me, "SuperAdmin");
export const isAdmin = (me: CurrentUser | undefined) => hasRole(me, "Admin");
export const isInstructor = (me: CurrentUser | undefined) => hasRole(me, "Instructor");

/** Can create/edit/delete/import questions. */
export const canManageQuestions = (me: CurrentUser | undefined) =>
  hasRole(me, "SuperAdmin") || hasRole(me, "Admin");
